document.addEventListener('DOMContentLoaded', () => {
	document
		.querySelectorAll('.wp-block-smlib-testimonials-set')
		.forEach((block) => {
			const dataElement = block.querySelector('.testimonials-set-data');
			const inner = block.querySelector('.testimonials-set-inner');

			if (!dataElement || !inner) {
				return;
			}

			let testimonials;

			try {
				testimonials = JSON.parse(dataElement.textContent);
			} catch (error) {
				return;
			}

			if (!Array.isArray(testimonials) || !testimonials.length) {
				return;
			}

			const testimonial =
				testimonials[Math.floor(Math.random() * testimonials.length)];

			inner.innerHTML = `
				<div class="wp-block-smlib-testimonial">
					<div class="block-inner">
						<blockquote class="wp-block-quote testimonial-quote is-layout-flow wp-block-quote-is-layout-flow">
							${testimonial.content}
						</blockquote>

						${
							testimonial.image
								? `<figure class="wp-block-image">
										${testimonial.image}
									</figure>`
								: ''
						}

						${
							testimonial.name
								? `<div class="wp-block-group block-author">
										<div class="wp-block-group__inner-container is-layout-flow wp-block-group-is-layout-flow">
											<p class="block-author__name">
												${testimonial.name}
											</p>

											${
												testimonial.title
													? `<p class="block-author__title">
															${testimonial.title}
														</p>`
													: ''
											}
										</div>
									</div>`
								: ''
						}
					</div>
				</div>
			`;
		});
});
